import { useHttpClient } from '@/common/api/httpClient';
import type { DashboardComponentTypeConfigResponse } from '../models/DashboardComponentTypeConfigResponse';

//exporterar funktionen för att kunna användas på andra ställen
export function useListManageDashboardComponentTypeConfigApi() {
  return {
    execute,
  };

  async function execute() {
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('dashboardComponentTypeConfig/manage'), {
      method: 'GET',
      headers,
    });

    const response = await httpClient.execute(request);
    if (response.ok) {
      const dashboardComponentTypeConfig =
        (await response.json()) as DashboardComponentTypeConfigResponse[];

      return dashboardComponentTypeConfig;
    }

    return [];
  }
}
